export const INVITE_EVENT_CONFIG = {
  eventEndDate: new Date('2025-12-31T23:59:59'),
  animation: {
    carouselRotationIntervalMs: 3000,
    transitionDurationSeconds: 0.6,
    easingCurve: [0.4, 0, 0.2, 1] as const,
  },
  share: {
    title: '웰로 친구 초대 이벤트',
    description: '친구 초대하고 웰포인트 받으세요!',
  },
} as const;
